import { sendEvent } from './sendEvent';

export const goToRequestReferral = () => {
  sendEvent('Medicine', 'ExpiredMedicineButtons');
  window.open(import.meta.env.VITE_APP_REQUEST_REFERRAL, '_blank');
};
